
const pixelRatio = window.devicePixelRatio || 1;

// Maximum likely time to miss pointer events (4 frames)
const timeout = 67;
// Number of touch points to buffer for extrapolation
const buffer = 4;


/**
 * @mixin Pointer capture and release for drag handling.
 * Pointer events are handled asynchronously from rendering for smoothness.
 */
export default {
    methods: {
        _dragcapture(el, e) {
            const touches = e.touches;
            if (touches) {
                if (touches.length == 1) {
                    this.__dragte();
                    this.__dragmu();
                    el.addEventListener('touchmove', this.__dragtm);
                    el.addEventListener('touchend', this.__dragte);
                    this._dragel = el;
                    this._dragx = this._dlx = touches[0].clientX;
                    this._dragy = this._dly = touches[0].clientY;
                } else {
                    return;
                }
            } else {
                this.__dragte();
                this.__dragmu();
                if (el.setCapture) {
                    el.setCapture();
                    el.addEventListener('mousemove', this.__dragmm);
                    el.addEventListener('mouseup', this.__dragmu);
                } else {
                    document.body.addEventListener('mousemove', this.__dragmm, true);
                    document.body.addEventListener('mouseup', this.__dragmu, true);
                    document.documentElement.addEventListener('mouseout', this.__dragmo);
                }
                this._dragel = el;
                this._dragx = this._dlx = e.clientX;
                this._dragy = this._dly = e.clientY;
            }
            this._dp = [[this._dragx, this._dragy, e.timeStamp]];
            this._di = 0;
            this._dd = performance.now() - e.timeStamp;
            if (this._dd < 0 || this._dd > 33) {  // sanity check (Safari desktop)
                this._dd = 0;
            }
            this._dragf = requestAnimationFrame(this.__dragframe);
        },

        /**
         * Called once per render frame; pointer events are asynchronous and extrapolated based on timestamp.
         * @private
         */
        __dragframe(timeStamp) {
            const p = this._dp;
            const i = this._di;
            const e = timeStamp - this._dd - p[i][2];
            if (e < timeout) {
                let x = p[i][0];
                let y = p[i][1];
                let l = p.length;
                for (let j = 1; j < l; j++) {
                    const k = (i + l - j) % l;
                    const d = p[i][2] - p[k][2];
                    if (d < timeout) {
                        const w = e / (d * j * j * 1.5);
                        x += (p[i][0] - p[k][0]) * w;
                        y += (p[i][1] - p[k][1]) * w;
                    }
                }
                if (this._dlx !== x || this._dly !== y) {
                    this._dlx = x;
                    this._dly = y;
                    this._dragmove(
                        ((x - this._dragx) * pixelRatio + .5 | 0) / pixelRatio,
                        ((y - this._dragy) * pixelRatio + .5 | 0) / pixelRatio);
                }
            }
            this._dragf = requestAnimationFrame(this.__dragframe);
        },

        /**
         * Called on touch move event; this is asynchronous from rendering.
         * @private
         */
        __dragtm(e) {
            this._dp[this._di = (this._di + 1) % buffer] = [e.touches[0].clientX, e.touches[0].clientY, this._dd ? e.timeStamp : performance.now()];
        },

        /**
         * Called on touch end.
         * @private
         */
        __dragte(e) {
            const el = this._dragel;
            if (el) {
                el.removeEventListener('touchmove', this.__dragtm);
                el.removeEventListener('touchend', this.__dragte);
                cancelAnimationFrame(this._dragf);
                if (e) {
                    this._dragel = null;
                    const changedTouches = e.changedTouches;
                    if (changedTouches.length == 1) {
                        this._dragup(changedTouches[0].clientX - this._dragx, changedTouches[0].clientY - this._dragy);
                    }
                    e.preventDefault();
                }
            }
        },

        /**
         * Called on mouse move event; this is asynchronous from rendering.
         * @private
         */
        __dragmm(e) {
            this._dp[this._di = (this._di + 1) % buffer] = [e.clientX, e.clientY, this._dd ? e.timeStamp : performance.now()];
        },

        /**
         * Called on mouseout.
         * @private
         */
        __dragmo(e) {
            if (e.target === document.documentElement) {
                this.__dragmu(e);
            }
        },

        /**
         * Called on mouseup.
         * @private
         */
        __dragmu(e) {
            const el = this._dragel;
            if (el) {
                if (el.releaseCapture) {
                    el.releaseCapture();
                    el.removeEventListener('mousemove', this.__dragmm);
                    el.removeEventListener('mouseup', this.__dragmu);
                } else {
                    document.body.removeEventListener('mousemove', this.__dragmm, true);
                    document.body.removeEventListener('mouseup', this.__dragmu, true);
                    document.documentElement.removeEventListener('mouseout', this.__dragmo);
                }
                cancelAnimationFrame(this._dragf);
                if (e) {
                    this._dragel = null;
                    this._dragup(e.clientX - this._dragx, e.clientY - this._dragy);
                } else {
                    this._dragup();
                }
            }
        }
    }
}
